export const FILTERING_OPERATORS = [":", "!:", "=", "!="];

export const EMPTY_STRING = "";
